import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { store } from '@/store';
import { BasketType } from '@/enums';
import IconOnlyRetailPrice from '../icons/IconOnlyRetailPrice.vue';
import IconAllPrices from '../icons/IconAllPrices.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HideB2BPricesButton',
  setup(__props) {

const hideB2BPrices = computed<boolean>(() => store.getters['hideb2bprices/hideB2BPrices']);
const isQuoteBasketVisible = computed<boolean>(() => store.getters['app/isQuoteBasketVisible']);

function toggle() : void {
    store.dispatch('hideb2bprices/toggle');
}
function fetchBasket(basketType: BasketType) : void {
    store.dispatch('basket/fetchBasket', basketType);
}

function toggleRetailPrice() {
    toggle();
    fetchBasket(BasketType.B2B);

    if (isQuoteBasketVisible.value) { fetchBasket(BasketType.Quotation); }
}

return { __sfc: true,hideB2BPrices, isQuoteBasketVisible, toggle, fetchBasket, toggleRetailPrice, IconOnlyRetailPrice, IconAllPrices }
}

})